module.exports = __webpack_public_path__ + "static/media/main-explosion.48703d0.ogg";


//////////////////
// WEBPACK FOOTER
// ./static/audio/main-explosion.ogg
// module id = m5+n
// module chunks = 1